module.exports = __webpack_public_path__ + "img/icon-teach-2.c3b1ddad.png";